import { useCallback, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog/dialog";

type Props = {
	hotelID: string;

	open: boolean;
	handleOpenChange: (open: boolean) => void;

	roomType: "STANDARD" | "DUMMY";
	onTransitionToCreateRoom: () => void;
};

export const DialogConfirmContinueCreateRoom = ({
	open,
	handleOpenChange: _handleOpenChange,
	hotelID,
	roomType,
	onTransitionToCreateRoom,
}: Props) => {
	const navigate = useNavigate();

	const onTransitionToRoomList = useCallback(() => {
		navigate(generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID }));
	}, [hotelID, navigate]);

	const handleClickTransitionToRoomList = useCallback(() => {
		onTransitionToRoomList();
	}, [onTransitionToRoomList]);

	const handleClickTransitionToCreateRoom = useCallback(() => {
		onTransitionToCreateRoom();
	}, [onTransitionToCreateRoom]);

	const handleOpenChange = useCallback(
		(open: boolean) => {
			if (!open) {
				onTransitionToRoomList();
			}

			_handleOpenChange(open);
		},
		[_handleOpenChange, onTransitionToRoomList],
	);

	const dialogTitle = useMemo(() => {
		return roomType === "STANDARD" ? "続けて通常の部屋を作成しますか？" : "続けてダミー部屋を作成しますか？";
	}, [roomType]);

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent hideCloseButton>
				<DialogHeader>
					<DialogTitle>{dialogTitle}</DialogTitle>
				</DialogHeader>

				<div className="flex justify-end gap-x-4 pt-6">
					<Button onClick={handleClickTransitionToRoomList} variant="outline">
						部屋一覧に戻る
					</Button>
					<Button onClick={handleClickTransitionToCreateRoom}>続けて作成する</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

DialogConfirmContinueCreateRoom.displayName = "DialogConfirmContinueCreateRoom";
